import { Config } from '@env/config';
import { Environment } from '@env/environment.enum';
import config from './config.json';

export const environment: Config = config[Environment.Jenkins];
